import * as React from "react";
import type { SVGProps } from "react";
const SvgEgyptair = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 50 50"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fill="#00265d"
      fillRule="evenodd"
      d="M32.967 12.706c1.193 1.413 2.936 1.916 4.05 1.104.698-.513.956-1.443.804-2.46.662.1 1.306.301 2.074.61.38.128.832-1.458.243-1.513-6.327-.91-9.84 4.19-9.754 4.109.977-.734 1.785-1.356 2.583-1.85m3.61.582c-.835.676-2.229.255-3.21-.824 1.321-.816 2.442-1.201 3.647-1.186.246.776.033 1.637-.437 2.01m-31.522 2.25a24.7 24.7 0 0 1 5.453-9.48C21.41 1.463 35.466 1.497 46 9.964 39.39 6.6 19.846 3.02 5.055 15.538M4.424 27.21a24.4 24.4 0 0 1-.198-7.835c7.715-7.831 19.26-12.985 31.38-10.454-6.634.015-22.536 4.554-31.182 18.289m4.126 9.644a24.4 24.4 0 0 1-3.1-5.876c4.59-9.705 13.44-18.158 25.334-19.998-5.92 2.228-18.257 11.297-22.234 25.874m7.486 6.91a24.6 24.6 0 0 1-4.96-3.887c1.584-10.26 7.86-20.984 17.896-26.55-.738 1.085-1.078 2.356-1.017 3.708-5.85 5.924-11.661 15.123-11.919 26.729M25.32 47a25.6 25.6 0 0 1-5.705-1.461c.067-9.287 3.082-20.314 8.555-27.075.304 1.185.88 2.401 1.813 3.62 4.332-5.09 9.329-8.69 15.534-10.281C37.057 15.01 23.887 25.243 25.32 47"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgEgyptair;
